export default "__VITE_ASSET__0rR9oCBa__"